import { useEffect, useState } from 'react';
import { graphql } from 'src/gql';

import { getImpersonateClientId } from '@savvy/deprecated-shared/utils/advisor-utils';
import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import { useOnboardingRedesign } from './use-onboarding-redesign';

const HasActiveEciClientOnboardingQuery = graphql(/* GraphQL */ `
  query HasActiveEciClientOnboarding($clientId: ID) {
    hasActiveEciClientOnboarding(clientId: $clientId)
  }
`);

export const CUSTODIAN_TRANSFER_ROUTE = '/custodian-transfer';

export const ONBOARDING_REDIRECT_DEADLINE_MS = 8000;

export function useActiveOnboardingRedirect({ enabled }: { enabled: boolean }): { redirect: boolean; ready: boolean } {
  const { isRedesign, flagsReady } = useOnboardingRedesign();
  const skip = !enabled || !flagsReady || !isRedesign;

  const { data, loading, error } = useQueryWithErrorLogging(HasActiveEciClientOnboardingQuery, {
    skip,
    fetchPolicy: 'cache-first',
    variables: { clientId: getImpersonateClientId() },
  });

  const [pastDeadline, setPastDeadline] = useState(false);

  useEffect(() => {
    if (skip || !loading || pastDeadline) {
      return undefined;
    }

    const timer = setTimeout(() => setPastDeadline(true), ONBOARDING_REDIRECT_DEADLINE_MS);
    return () => clearTimeout(timer);
  }, [skip, loading, pastDeadline]);

  if (!enabled) {
    return { redirect: false, ready: true };
  }

  if (!flagsReady) {
    return { redirect: false, ready: false };
  }

  if (!isRedesign) {
    return { redirect: false, ready: true };
  }

  if (pastDeadline) {
    return { redirect: false, ready: true };
  }

  if (loading) {
    return { redirect: false, ready: false };
  }

  return { redirect: !error && data?.hasActiveEciClientOnboarding === true, ready: true };
}
